import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Client from './Client';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Button from '@material-ui/core/Button';
import { ClientFormAdd } from './ClientForm';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';

const Clients = () => {
  const [clients, setClients] = useState([]);
  const [addClient, setAddClient] = useState(false);
  const history = useHistory();

  const fetchClients = () => {
    fetch(process.env.REACT_APP_PROXY_HOST + '/liste/clients', { method: 'GET' })
      .then((res) => res.json())
      .then((data) => setClients(data));
  };

  const handleEvent = (client, editMode) => {
    history.push({
      pathname: '/client/' + client._id,
      clientid: client._id,
      state: { client, editMode },
    });
  };

  const deleteClient = (client) => {
    fetch(process.env.REACT_APP_PROXY_HOST + '/liste/clients/' + client._id, { method: 'DELETE' })
      .then(fetchClients);
  };

  function hasCommit() {
    fetchClients();
  }

  useEffect(() => {
    fetchClients();
  }, []);

  return (
    <div>
      <h1>Clients</h1>
      <List component="nav" aria-label="secondary mailbox folders">
        {clients.map((client) => (
          <ListItem button key={client._id} onClick={() => handleEvent(client, false)}>
            <ListItemText><Client _id={client._id} /></ListItemText>
            <ListItemSecondaryAction>
              <IconButton edge="end" aria-label="edit" onClick={() => handleEvent(client, true)}><EditIcon /></IconButton>
              <IconButton edge="end" aria-label="delete" onClick={() => deleteClient(client)}><DeleteIcon /></IconButton>
            </ListItemSecondaryAction>
          </ListItem>
        ))}
      </List>
      <Button variant="contained" color="primary" onClick={() => setAddClient(true)}>Ajouter</Button>
      {addClient && (
        <div>
          <ClientFormAdd clients={clients} hasCommit={hasCommit} />
          <Button variant="contained" color="secondary" onClick={() => setAddClient(false)}>Annuler</Button>
        </div>
      )}
    </div>
  );
};

export default Clients;



// WEBPACK FOOTER //
// src/components/clients/Clients.js